/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Success_HeadingInputs */

const et_contact_success_heading = /** @type {(inputs: Contact_Success_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aitäh päringu eest! 🎉`)
};

const en_contact_success_heading = /** @type {(inputs: Contact_Success_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thank you for your inquiry! 🎉`)
};

/**
* | output |
* | --- |
* | "Thank you for your inquiry! 🎉" |
*
* @param {Contact_Success_HeadingInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const contact_success_heading = /** @type {((inputs?: Contact_Success_HeadingInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Success_HeadingInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_contact_success_heading(inputs)
	return en_contact_success_heading(inputs)
});